import { useState } from 'react'
import Slider from 'react-slick'
import Lightbox from 'react-images'
import get from 'lodash/get'

import './dive-center-photos.scss'

const theme = {
  footerCaption: {
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: '16px',
  },
}
const settings = {
  slidesToShow: 4,
  slidesToScroll: 4,
  infinite: false,
  dots: true,
  arrows: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        slidesToShow: 1.2,
        slidesToScroll: 1,
        dots: false,
      },
    },
  ],
}

export default function DiveCenterPhotos({ images }) {
  const [isOpen, setPopupOpen] = useState(false)
  const [currentImage, setCurrentImage] = useState(0)

  const gotoPrevious = () => {
    setCurrentImage(currentImage - 1)
  }

  const gotoNext = () => {
    setCurrentImage(currentImage + 1)
  }

  const gotoImage = (index) => setCurrentImage(index)

  const closeLightbox = () => {
    setPopupOpen(false)
    gotoImage(0)
  }

  const openLightBox = () => {
    setPopupOpen(true)
  }

  if(!get(images, 'length')) {
    return ''
  }

  return (
    <div className='images-gallery-wrapper'>
      <Lightbox
        images={images}
        currentImage={currentImage}
        isOpen={isOpen}
        onClickPrev={gotoPrevious}
        onClickNext={gotoNext}
        width={window.innerWidth * 0.9}
        onClickThumbnail={gotoImage}
        showThumbnails
        theme={theme}
        onClose={closeLightbox}
      />
      <div className='images-gallery'>
        <Slider className='slick-pt-custom' {...settings}>
          {images.map((image, index) => {
            return (
              <div
                className='images-gallery__image-container'
                key={index}
                onClick={openLightBox}
              >
                <span
                  className='images-gallery__image pointer'
                  style={{ backgroundImage: `url(${image.thumbnailUrl})` }}
                />
              </div>
            )
          })}
        </Slider>
      </div>
    </div>
  )
}
